module.exports = __webpack_public_path__ + "img/Radfahren.cf9a8f8f.svg";